export const partnershipAssets = {
  aiButtonStars: {
    star: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star.webp`,
    star2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star2.webp`,
    star3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star3.webp`,
    star4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star4.webp`,
    star5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star5.webp`,
    starDark: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star-dark.webp`,
    starDark2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star-dark2.webp`,
    starDark3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star-dark3.webp`,
    starDark4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/ai-button/star-dark4.webp`,
  },
  becomePartner: {
    benifit: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/become-a-partner/benifit.svg`,
    eligibility: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/become-a-partner/eligblity.svg`,
    responsibility: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/become-a-partner/responsiblity.svg`,
    dedicatedAccountManager: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/become-a-partner/dedicated-account-manager.svg`,
    industryLeadingTechnologies: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/become-a-partner/industry-leading-technology.svg`,
    loyalClientele: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/become-a-partner/loyal-cliente.svg`,
    richAndDiversePortfolio: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/become-a-partner/rich-and-diverse.svg`,
  },
  approachSteps: {
    discovery: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/approach-steps/discovery.svg`,
  },
};
